// @flow

import * as React from 'react';
import trackEventAJAX from '@ta/common.tracking';
import classNames from '@ta/common.classnames';
import { localize, unescaped } from '@ta/common.i18n';
import { LoadingSpinner } from '@ta/styleguide.loading';
import { ProfileCardResponsive } from '@ta/social.cards';

import styles from './SuggestedFacebookMembers.less';

type Props = {
  connections: any,
  loading: boolean,
  error: any,
  refetch: any,
  contentRef: React.ElementRef<*>,
  status: string,
};

const module = 'Social_suggested_fb_members';
let trackingLogged = false;

const SuggestedFacebookMembers = (props: Props) => {
  const Refetch = ({ refetch }: { refetch: () => void }) => (
    <div className={classNames(styles.message_area, styles.refetch)}>
      {/* We had trouble finding your Facebook friends. */}
      {localize('onboarding_social_fbfollow_screen_header_error_cant_get_friends')}
      <button
        className="ui_button standard"
        onClick={e => {
          e.preventDefault();
          refetch();
        }}
      >
        {/* Try again */}
        {localize('onboarding_social_fbfollow_screen_header_error_try_again')}
      </button>
    </div>
  );

  const Loading = () => (
    <div className="ui_card section">
      <LoadingSpinner />
    </div>
  );

  const AllSet = () => (
    <div className={styles.message_area}>
      {/* All set! You&#39;re already connected to all of your Facebook friends with accounts on TripAdvisor. */}
      {unescaped(localize('social_All_set_no_more_Facebook_connections'))}
    </div>
  );

  if (props.error) {
    return <Refetch refetch={props.refetch} />;
  }

  // If the query data shows 'PENDING', the friend data is not yet available. Reattempt the query before showing an error screen.
  if (props.status && props.status === 'PENDING') {
    props.refetch();
    return <Loading />;
  } else if (props.status && props.status === 'FAILED') {
    return <Refetch refetch={props.refetch} />;
  }

  if (props.status && props.status === 'COMPLETE' && props.connections.length === 0) {
    return <AllSet />;
  }

  if (!trackingLogged) {
    trackEventAJAX({
      module,
      action: 'Social_suggested_fb_members_got_friends',
      context: props.connections.length.toString(),
    });
    trackingLogged = true;
  }

  return (
    <div ref={props.contentRef}>
      {props.connections.map(profile =>
        profile ? (
          <ProfileCardResponsive
            key={profile.userProfile.userId}
            profile={{
              ...profile.userProfile,
              displayName: profile.fullName,
            }}
          />
        ) : null,
      )}
      {props.loading && <Loading />}
    </div>
  );
};

export default SuggestedFacebookMembers;
